import React, {Component} from 'react';
import PropTypes from 'prop-types';
import StripeCheckout from 'react-stripe-checkout';

import STRIPE_PUBLISHABLE from '../../stripe';
import PAYMENT_SERVER_URL from '../../server';

const CURRENCY = 'USD';

const fromDollarToCent = amount => amount * 100;

const successPayment = data => {
  alert('Payment Successful');
};

const errorPayment = data => {
  alert('Payment Error');
};

const onToken = (amount, description) => token =>
alert('Done');
	
const Checkout = ({ name, description, amount }) =>
  <StripeCheckout
    name={name}
    description={description}
    amount={fromDollarToCent(amount)}
    token={onToken(amount, description)}
    currency={CURRENCY}
    stripeKey={STRIPE_PUBLISHABLE}
  />

export default Checkout;



// WEBPACK FOOTER //
// ./src/components/Checkout/Checkout.js